import React, { useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import CommonDialogDataGrid from "../components/CommonDialogDataGrid";

const UpdateRuleMapDialog = ({
  open,
  onClose,
  onSave,
  allRules,
  mappedRuleKeys,
}) => {
  // Seed local selection once from props
  const [selectedKeys, setSelectedKeys] = useState(() => mappedRuleKeys || []);

  // Compute diffs + "hasChanges" without effects
  const { added, removed, hasChanges } = useMemo(() => {
    const addedLocal = selectedKeys.filter((k) => !mappedRuleKeys.includes(k));
    const removedLocal = mappedRuleKeys.filter(
      (k) => !selectedKeys.includes(k)
    );
    return {
      added: addedLocal,
      removed: removedLocal,
      hasChanges: addedLocal.length > 0 || removedLocal.length > 0,
    };
  }, [selectedKeys, mappedRuleKeys]);

  const handleSave = () => {
    onSave(added, removed);
  };

  // Only sort for initial presentation; rows themselves are static here
  const sortedInitialRows = useMemo(() => {
    return [...allRules]
      .sort((a, b) => {
        const aSelected = mappedRuleKeys.includes(a.ruleConfigRuleKey);
        const bSelected = mappedRuleKeys.includes(b.ruleConfigRuleKey);
        return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
      })
      .map((r) => ({
        id: r.ruleConfigRuleKey,
        ruleConfigRuleName: r.ruleConfigRuleName,
        ruleSetCount: r.ruleSetCount,
      }));
  }, [allRules, mappedRuleKeys]);

  const columns = [
    { field: "id", headerName: "Rule Key", flex: 1 },
    { field: "ruleConfigRuleName", headerName: "Rule Name", flex: 2 },
    { field: "ruleSetCount", headerName: "# of Rule sets", flex: 1 },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      // Optional: remount the dialog (and thus re-seed selectedKeys)
      // whenever mappedRuleKeys changes.
      // key={mappedRuleKeys.join(",")}
    >
      <DialogTitle>Update Rule Mapping</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            height: "calc(100vh - 300px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CommonDialogDataGrid
            // Or key the grid instead of the whole dialog:
            // key={mappedRuleKeys.join(",")}
            rows={sortedInitialRows}
            columns={columns}
            checkboxSelection
            selectionModel={selectedKeys}
            onSelectionChange={(newSelection) => setSelectedKeys(newSelection)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!hasChanges}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateRuleMapDialog;
